var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5766 29.4655C28.0133 29.4655 29.9887 27.4933 29.9887 25.0604C29.9887 22.6275 28.0133 20.6553 25.5766 20.6553C23.1399 20.6553 21.1646 22.6275 21.1646 25.0604C21.1646 27.4933 23.1399 29.4655 25.5766 29.4655Z",
    fill: "#27AAE1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.7943 32.8723C46.9306 23.3108 42.5203 12.2118 32.9436 8.08209C23.367 3.95236 12.2506 8.35572 8.11432 17.9173C3.97808 27.4788 8.38838 38.5778 17.965 42.7075C27.5416 46.8372 38.6581 42.4339 42.7943 32.8723Z",
    fill: "url(#paint0_radial_2265_69050)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2265_69050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4653 25.392) scale(18.8882 18.8585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDot);
export default __webpack_public_path__ + "static/media/light-dot.252b840696cabe32e3d7efc3e35ad5bd.svg";
export { ForwardRef as ReactComponent };